<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            type="primary"
            title="جدید"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="create"
          />
          <hr />
          <bita-form ref="filterForm">
            <div slot="body"></div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
    <gamifications-form ref="gamificationForm" @load-data="loadData" />
  </div>
</template>
<script>
import { gamificationsApi } from "@/api/apiManagement.js";
import gamificationsForm from "./components/GamificationsForm";

export default {
  components: { gamificationsForm },
  data() {
    return {
      pageSize: 10,
      filters: {},
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "هدیه های خرید",
          link: "/shop/gamifications",
          active: true,
        },
      ],
      isLoadingGrid: false,
      title: "",
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "بازه خرید", template: (e) => this.rangeTemplate(e) },
        { title: "هدیه", template: (e) => this.valueTemplate(e) },
        // { title: "توضیحات", template: e => (e.description ? e.description : '-' ) },
        { title: "عملیات", command: this.gridCommands() },
      ];
    },
  },
  methods: {
    valueTemplate(e) {
      if (e.type == 1)
        return this.$currencyLabel(this.$thousandSeprator(e.value));
      return `${e.value} (%)`;
    },
    rangeTemplate(e) {
      return `از ${this.$thousandSeprator(e.from)} تا ${e.to > 0 ? this.$thousandSeprator(e.to) : 'بی نهایت'}`;
    },
    readData(e) {
      this.isLoadingGrid = true;
      gamificationsApi
        .get(this.filters)
        .then((res) => {
          e.success(res.data.entity);
        })
        .catch(() => e.success([]))
        .finally(() => (this.isLoadingGrid = false));
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];

      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    edit(e) {
      this.isLoadingGrid = true;
      let row = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.gamificationForm.setInitialData(row);
      this.$toggleModal("#gamification-form");
      this.isLoadingGrid = false;
    },
    delete(e) {
      let standard = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          gamificationsApi
            .delete(standard.id)
            .then((res) => {
              this.$izitoast("success", "موفق!", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    create() {
      this.title = "افزودن هدیه خرید";
      this.$toggleModal("#gamification-form");
      this.$refs.gamificationForm.setInitialData({});
    },
  },
};
</script>
